import React, { useEffect, useState } from 'react';
import {
  Modal, Form, Button, Alert,
} from 'react-bootstrap';
import BillingoService from '../../Services/BillingoService';
import { docTypeLabel } from '../../Utils/billingoDocuments';

// Email a Billingo document (PDF attached) to one or more recipients. The
// recipient is prefilled (default: the booking's customer email) and editable.
function BillingoSendModal({
  show, onHide, doc, defaultEmail = '', onSent = () => {},
}) {
  const [emails, setEmails] = useState(defaultEmail);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [sentTo, setSentTo] = useState(null);

  useEffect(() => {
    if (show) {
      setEmails(defaultEmail);
      setError('');
      setSentTo(null);
    }
  }, [show, defaultEmail]);

  const handleSend = async () => {
    const list = emails.split(/[\s,;]+/).map((s) => s.trim()).filter(Boolean);
    if (list.length === 0) { setError('Enter at least one recipient email.'); return; }
    setSending(true);
    setError('');
    try {
      const res = await BillingoService.sendDocument({
        billingo_document_id: doc?.billingo_document_id,
        emails: list,
      });
      setSentTo(res?.sent_to || list);
      onSent();
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to send');
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="md">
      <Modal.Header closeButton>
        <Modal.Title>
          Send
          {' '}
          {doc ? docTypeLabel(doc.type) : 'document'}
          {doc?.number ? ` ${doc.number}` : ''}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        {sentTo ? (
          <Alert variant="success" className="mb-0">
            <i className="fa fa-check me-1" />
            Sent to
            {' '}
            {sentTo.join(', ')}
          </Alert>
        ) : (
          <Form.Group controlId="billingo-send-emails">
            <Form.Label>Recipient email(s)</Form.Label>
            <Form.Control
              value={emails}
              placeholder="customer@example.com, finance@partner.com"
              onChange={(e) => setEmails(e.target.value)}
            />
            <Form.Text className="text-muted">
              The PDF is attached. Separate multiple recipients with commas.
            </Form.Text>
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        {sentTo ? (
          <Button onClick={onHide}>Done</Button>
        ) : (
          <>
            <Button variant="outline-secondary" onClick={onHide} disabled={sending}>Cancel</Button>
            <Button onClick={handleSend} disabled={sending || !emails.trim()}>
              {sending ? 'Sending…' : 'Send'}
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default BillingoSendModal;
